import { useCallback, useState } from 'react';
import * as Sentry from '@sentry/browser';
import axios from 'axios';

import { userListApi } from '@/services/api/userList';
import { useApiErrorHandler } from '@/hooks/useApiErrorHandler';

export const useFetchUserList = () => {
  const { apiErrorHandler } = useApiErrorHandler();
  const [isLoading, setIsLoading] = useState(false);

  const fetchUserList = useCallback(
    async (organizationId: number) => {
      let result = null;

      try {
        setIsLoading(true);

        const {
          data: { users },
        } = await userListApi.getUsers(organizationId);

        result = users;
      } catch (err) {
        if (
          axios.isAxiosError(err) &&
          err.response &&
          err.response.status === 401
        ) {
          try {
            localStorage.clear();
          } catch (e) {
            Sentry.captureException(e);
          }
        }
        apiErrorHandler(err);
      } finally {
        setIsLoading(false);
      }

      return result;
    },
    [apiErrorHandler],
  );

  return { fetchUserList, isLoading };
};
